import { render, staticRenderFns } from "./ViewKnowledgeRep.vue?vue&type=template&id=814c404c&scoped=true"
import script from "./ViewKnowledgeRep.vue?vue&type=script&lang=js"
export * from "./ViewKnowledgeRep.vue?vue&type=script&lang=js"
import style0 from "./ViewKnowledgeRep.vue?vue&type=style&index=0&id=814c404c&prod&lang=css"
import style1 from "./ViewKnowledgeRep.vue?vue&type=style&index=1&id=814c404c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814c404c",
  null
  
)

export default component.exports